<div class="appToolbar">
  <div class="appToolbar_nav">
    <button class="dsButton dsButton-primary">
      <i class="dsButton_prefix dsIcon icon-add"></i>
      Create
    </button>
    <button class="dsButton">
      <i class="dsButton_prefix dsIcon icon-edit"></i>
      Edit
    </button>
  </div>
  <div class="appToolbar_options"></div>
</div>
